import { ICol } from '@core/interfaces/ICol';

export default function parseCol(str: string, keys: string[]): ICol {
    return str
        .split(',')
        .map((str) => {
            const [i, v] = str.split('+');
            const field = keys[+i];
            const val = v === '1';
            return { field, val };
        })
        .reduce(
            (res, item) => ({ ...res, [item.field]: item.val }),
            {} as ICol,
        );
}
